var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.tableData),function(value,title){return _c('div',{key:title},[_c('DetailsInfoTable',{attrs:{"title":title,"details-info":value}})],1)}),_c('MemoTimelineSection')],2)}
var staticRenderFns = []

export { render, staticRenderFns }